<template>
  <p :class="{'paraleft': paraleftside, 'pararight': pararightside}"> <slot /></p>
</template>

<script>
export default {
    props: ['paratext', 'paraleftside', 'pararightside']
}
</script>

<style scoped>
/* @media only screen and (max-width: 992px){
  p{
    font-size: 16px !important;
  }
} */

  p{
    /* padding-top: 5px;
    padding-bottom: 5px; */
    font-size: 18px;
    color: #414042 !important;
    font-family: 'Seravek-Light';
  }

  .paraleft{
    text-align: left;
    font-family: 'Seravek-Light';
  }

  .pararight{
    text-align: right;
    font-family: 'Seravek-Light';
  }

@media only screen and (max-width: 992px){
  .paraleft,
  .pararight{
    font-size: 16px;
  }
}
</style>